import * as Yup from "yup";
import { transformSnakeToCamel } from "utils/transform";

/**
 * Commission Schema
 * Represents commission earned by an affiliate
 */
export const CommissionSchema = Yup.object()
  .transform(transformSnakeToCamel)
  .shape({
    affiliateId: Yup.number().nullable(),
    campaignId: Yup.number().nullable(),
    commissionId: Yup.number().nullable(),
    conversionId: Yup.number().nullable(),
    urlId: Yup.number().nullable(),
    commissionEarned: Yup.number().nullable(),
    bonusEarned: Yup.number().nullable(),
    totalIncome: Yup.number().nullable(),
    paymentStatus: Yup.string().oneOf(["pending", "paid"]).nullable(),
    paymentDate: Yup.date().nullable(),
    commissionMonth: Yup.string().oneOf(["jun", "feb", "mar", "apr", "may", "jun", "jul", "aug", "sep", "oct", "nov", "dec"]).nullable(),
  });
